const useTheme = () => {
  const darkMode =localStorage.getItem("darkMode") === "true";

  return {
    darkMode,
    colors: {
      bg: {
        primary: darkMode ? "bg-gray-950" : "bg-gray-50",
        secondary: darkMode ? "bg-gray-900" : "bg-white",
        card: darkMode ? "bg-gray-900/50" : "bg-white",
        hover: darkMode ? "hover:bg-gray-800/80" : "hover:bg-gray-50",
      },
      text: {
        primary: darkMode ? "text-gray-100" : "text-gray-900",
        secondary: darkMode ? "text-gray-400" : "text-gray-600",
        muted: darkMode ? "text-gray-500" : "text-gray-500",
      },
      border: {
        primary: darkMode ? "border-gray-800" : "border-gray-200",
        secondary: darkMode ? "border-gray-700" : "border-gray-300",
      },
      status: {
        completed: darkMode
          ? "bg-emerald-500/10 text-emerald-400 border-emerald-500/20"
          : "bg-emerald-100 text-emerald-800 border-emerald-200",
        scheduled: darkMode
          ? "bg-blue-500/10 text-blue-400 border-blue-500/20"
          : "bg-blue-100 text-blue-800 border-blue-200",
        pending: darkMode
          ? "bg-amber-500/10 text-amber-400 border-amber-500/20"
          : "bg-amber-100 text-amber-800 border-amber-200",
      },
      accent: {
        primary: darkMode
          ? "bg-gradient-to-r from-blue-600 to-indigo-600"
          : "bg-gradient-to-r from-blue-500 to-indigo-500",
        hover: darkMode
          ? "hover:from-blue-700 hover:to-indigo-700"
          : "hover:from-blue-600 hover:to-indigo-600",
        text: "text-white",
      },
    },
  };
};

export default useTheme;